<template>
  <section class="dashboard-container">
    <h1 class="dashboard-title">{{ business.tradeName }}</h1>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DashboardPage",
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters({
      business: "app/getBusiness",
      showViewAdmin: "app/getShowViewAdmin",
    }),
  },
};
</script>

<style lang="stylus">
@import "../Styles/Dashboard.styl"
</style>
